import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Button, Card, Result } from 'antd-mobile-v5'
import { FormattedMessage, useIntl } from 'react-intl'
import { formatMoney } from '../../components/common/utils'

import styles from './CreditResult.module.css'

// 物流信息行：v5 无 Flex，两列布局由 CSS module 承载（与 FormTools/DiverInfo 的 CSS 两列先例一致）
const ShippingRow = ({ labelId, children }) => (
  <div className={styles.row}>
    <span>
      <FormattedMessage id={labelId} />
    </span>
    <span>{children}</span>
  </div>
)

const CreditResult = () => {
  const history = useHistory()
  const { formatMessage } = useIntl()
  const {
    state: { payResult },
  } = useLocation()

  if (!payResult) return null

  // 币种：后端 DTO currencyType 可能为空（教材 Stripe 直付不返回），回退商品携带的币种
  const currencyType =
    payResult.currencyType || (payResult.items && payResult.items[0] && payResult.items[0].currencyType)
  const renderPrice = (price) => (currencyType ? formatMoney(price, currencyType) : price)
  const { shipping } = payResult

  return (
    <div className={styles.page}>
      <Result status="success" title={formatMessage({ id: 'credit-card-pay-success' })} />
      <div className={styles.section}>
        <Card title={formatMessage({ id: 'paypal-order-detail' })}>
          <div>
            <FormattedMessage id="paypal-order-number" />
            {payResult.id}
          </div>
          <div className={styles['item-list']}>
            {payResult.items.map((item, index) => {
              // 单价：Stripe DTO 返回 unitPrice；BooksCheckout 分支商品自带 price（原价）
              const unitPrice = item.unitPrice != null ? item.unitPrice : item.price
              // 同名商品 key 会冲突：name+index 保证唯一（成功页列表静态、不会重排）
              return (
                <div className={styles.item} key={item.name + '-' + index}>
                  <div>
                    <FormattedMessage id="paypal-goods-name" />
                    {item.name}
                  </div>
                  {item.quantity && (
                    <div>
                      <FormattedMessage id="paypal-goods-quantity" />
                      {item.quantity}
                    </div>
                  )}
                  {unitPrice != null && (
                    <div>
                      <FormattedMessage id="pay-success-unit-price" />
                      {renderPrice(unitPrice)}
                    </div>
                  )}
                </div>
              )
            })}
          </div>
          <div className={styles.total}>
            <FormattedMessage id="paypal-order-price" />
            {renderPrice(payResult.price)}
          </div>
        </Card>
      </div>
      {shipping && (
        <div className={styles.section}>
          <Card title={formatMessage({ id: 'pay-success-shipping-info' })}>
            {shipping.userName && <ShippingRow labelId="addressForm-contact">{shipping.userName}</ShippingRow>}
            {shipping.userMobile && <ShippingRow labelId="addressForm-mobile">{shipping.userMobile}</ShippingRow>}
            {shipping.province ? (
              <ShippingRow labelId="addressForm-province">
                {shipping.province}
                {shipping.city ? ` ${shipping.city}` : ''}
              </ShippingRow>
            ) : (
              shipping.region && <ShippingRow labelId="addressForm-region">{shipping.region}</ShippingRow>
            )}
            {shipping.address && <ShippingRow labelId="addressForm-address">{shipping.address}</ShippingRow>}
          </Card>
        </div>
      )}
      {/* 订单备注（CHNA-2753）：教材下单填写，随 payResult 带过来；其它业务（eCard/代购）不带该字段，天然不显示 */}
      {payResult.remark && (
        <div className={styles.section}>
          <Card title={formatMessage({ id: 'order-remark' })}>
            <div className={styles.remark}>{payResult.remark}</div>
          </Card>
        </div>
      )}
      <div className={styles['btn-wrap']}>
        <Button block color="primary" onClick={() => history.push('/certs')}>
          <FormattedMessage id="common-back-home" />
        </Button>
      </div>
    </div>
  )
}

export default CreditResult
